import PropTypes from 'prop-types'
import React from 'react'

const propTypes = {
  label: PropTypes.string,
  size: PropTypes.oneOf(['md', 'sm', 'xs']),
}

function Spinner(props) {
  const { label, size = 'md' } = props

  return (
    <svg aria-label={label} className={`spin spin-${size} align-items-center`} viewBox="0 0 50 50" role="status">
      <circle className="path" cx="25" cy="25" r={size === 'md' ? '20' : '15'} fill="none" strokeWidth="5" />
    </svg>
  )
}

Spinner.propTypes = propTypes

export default Spinner
